<template>
  <section class="closefriend-hero h-100" >
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container mt-5">
      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
          <div class="login-card position-relative">
            <button type="button" class="close position-absolute" style="right: 15px; top: 10px; z-index: 10; color: #fff; font-size: 30px;" aria-label="Close" @click="$router.replace({name: 'CustomRequestOptionList'})">
              <span aria-hidden="true">&times;</span>
            </button>
            <global-message></global-message>
            <div class="login-body mt-3">
              <div class="row">
                <div class="col-12 mt-2">
                  <label class="form-label mb-2">Title</label>
                  <div class="stella-group">
                    <input type="text" maxlength="60" class="form-control text-white" style="background: transparent !important; color: white !important;" v-model="customRequestOption.title">
                  </div>
                  <div class="invalid-feedback" v-if="isRequired('title')">You haven't filled this field</div>
                </div>
                <div class="col-12 mt-4 mb-3 d-flex justify-content-between align-items-start">
                  <div>
                    <label class="form-label mb-2">Price</label>
                    <div class="input-group" style="max-width: 150px;">
                      <div class="input-group-prepend">
                        <span class="input-group-text" style="background-color: #333; color: #fff; border: 1px solid #333; border-right: none;">$</span>
                      </div>
                      <input type="number" min="0" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                             class="form-control text-white" style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important; border-left: none;"
                             v-model="customRequestOption.price">
                    </div>
                    <div class="text-danger mt-1 font-size-12" v-if="isRequired('price')">You haven't filled this field</div>
                  </div>
                  <div class="mt-4 pt-1">
                    <button type="button"
                            class="btn stella-btn gradient-a rounded-pill font-weight-500 px-5 py-2 w-auto"
                            @click="createOrUpdateCustomRequest()">
                      <span class="text-white font-size-14 font-weight-600">Save</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import {required} from "vuelidate/lib/validators";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import {constructCustomerURL} from "@/common/baseURL-service";
import titleMixin from "../../../../mixin/title-mixin";


export default {
  name: 'CustomRequestOptionCreate',
  title: 'Create custom request option',
  mixins: [newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu,
    GlobalMessage,
    PwaActionBar
  },
  data() {
    return {
      user: [],
      customRequestOption: {},
      showSlideBar: false,

      isSubmitted: false

    }
  },
  validations() {
    return {
      customRequestOption: {
        title: {required},
        price: {required}
      }
    }
  },
  created() {
    this.user = this.getUser();
    if (this.isEdit) {
      this.load();
    }
    this.checkNewSubscription(this.user.id);
  },
  computed: {
    isEdit() {
      return !!this.$route.params.customRequestOptionId;
    },
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setMessage']),
    constructCustomerURL,
    isRequired(attrib) {
      return this.isSubmitted && !this.$v.customRequestOption[attrib].required;
    },
    createOrUpdateCustomRequest() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (!this.isEdit) {
        this.create();
      } else {
        this.update();
      }
    },
    load() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/${this.$route.params.customRequestOptionId}`;
      this.getData(url, (customRequestOption) => {
        this.customRequestOption = customRequestOption;
      });

    },
    create() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/`;
      this.postData(url, this.customRequestOption, (customRequestOptions) => {
        this.customRequestOptions = customRequestOptions;
        this.$store.dispatch('setMessage', 'Custom request option created successfully.');
        this.goto({saved: true});
      });
    },
    update() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/${this.customRequestOption.id}`;
      this.patchData(url, this.customRequestOption, (customRequestOptions) => {
        this.customRequestOptions = customRequestOptions;
        this.$store.dispatch('setMessage', 'Custom request option updated successfully.');
        this.goto({saved: true});
      });
    },
    goto(query) {
      this.$router.replace({name: 'CustomRequestOptionList', query});
    },
    deleteCustomRequest() {
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/custom-request-options/${this.customRequestOption.id}`;
      this.getDelete(url, () => {
        this.$store.dispatch('setMessage', 'Custom request option deleted.');
        this.goto({deleted: true});
      });

    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    }
  }
}
;
</script>


